export { EditarExame } from './EditarExame'
